// Utility to join class names conditionally (commonly used in React)
export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}
